<template>
    <Header cur="หน้าแรก" />
    <div class="home-top">
        <div class="top-content">เมื่อการเงินพบกับเทคโนโลยีอนาคตของคุณเริ่มต้นที่นี่</div>
        <img class="top-img" src="@/assets/home-top.webp" alt="">
    </div>
    <div class="home-about">
        <div class="about-title">เกี่ยวกับเรา</div>
        <div class="about-content">
            <img class="content-img" src="../assets/aboutImg.webp" />
            <div class="content-text">
                Thai LoanTech Platforms Company Limited
                ก่อตั้งขึ้นในประเทศไทยและมุ่งมั่นเดินหน้าสู่ความสำเร็จตั้งแต่เริ่มต้น
                ทุ่มเทอย่างเต็มที่เพื่อนำเสนอบริการทางการเงินคุณภาพสูงและผลิตภัณฑ์ที่ล้ำสมัย
                โดยมุ่งเน้นการขยายธุรกิจเพื่อการเติบโตที่มั่นคง
                พร้อมทั้งพัฒนานวัตกรรมด้านเทคโนโลยีเพื่อสร้างประสบการณ์การกู้ยืมที่มีคุณภาพ
                เราให้ความสำคัญกับความต้องการของลูกค้าเป็นอันดับแรก เข้าใจความต้องการด้านการเงินอย่างแม่นยำ
                และนำเสนอทางออกที่ปรับให้เหมาะสมที่สุด ยึดมั่นในหลักการความซื่อสัตย์และความเป็นเลิศ
                ร่วมสร้างความสัมพันธ์ที่ยั่งยืนกับพันธมิตรทางธุรกิจ โดยมีเป้าหมายความพึงพอใจของลูกค้าเป็นสำคัญ
                พัฒนาและปรับปรุงบริการอย่างต่อเนื่อง เพื่อก้าวสู่การเป็นผู้นำในกระแสฟินเทค
                และร่วมสร้างอนาคตที่รุ่งโรจน์ของวงการการเงินไทยไปพร้อมกัน
            </div>
        </div>
    </div>
    <div class="home-service">
        <div class="service-title">บริการของเรา</div>
        <div class="service-dics">
            ในกระแสการเปลี่ยนแปลงอย่างรวดเร็วของฟินเทค Thai LoanTech Platforms Company Limited
            เปรียบเสมือนเรือใหญ่ที่มุ่งหน้าไปข้างหน้าอย่างมั่นคง
            ด้วยการมองการณ์ไกลในตลาดและความสามารถด้านนวัตกรรมที่ยอดเยี่ยม
            เรามุ่งเน้นในด้านสำคัญเพื่อสร้างพลังใหม่ให้กับประเทศไทยและตลาดที่กว้างขึ้น โดยมีจุดมุ่งหมายหลักดังนี้:
        </div>
        <div class="service-content">
            <div class="content-item" v-for="item in list" :key="item.index">
                <img v-if="item.index == 4" class="item-more" src="../assets/serviceIcon4.webp" alt="">
                <div v-else>
                    <div class="item-title">{{ item.title }}</div>
                    <div class="item-content">
                        <img class="item-img" :src="require('@/assets/serviceIcon' + item.index + '.webp')" alt="">
                        <div class="item-text">{{ item.content }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Footer />
</template>
<script setup>
import Header from "@/components/HeaderCom.vue";
import Footer from "@/components/FooterCom.vue";

const list = [
    {
        title: "บริการทางการเงินครบวงจร",
        content:
            "มอบบริการกู้ยืมคุณภาพสูง ครอบคลุมทั้งการหมุนเวียนเงินทุน การลงทุน และการบริโภค พร้อมโซลูชันที่ปรับให้เหมาะสมสำหรับลูกค้าแต่ละราย",
        index: 1,
    },
    {
        title: "เทคโนโลยีเสริมสร้างการกู้ยืม",
        content:
            "ใช้ AI และบิ๊กดาต้าปรับปรุงกระบวนการอนุมัติ ลดเวลารอคอย มอบประสบการณ์การกู้ยืมที่รวดเร็วและสะดวกสบาย",
        index: 2,
    },
    {
        title: "ความร่วมมือเพื่อเติบโต",
        content:
            "ขยายธุรกิจและสร้างพันธมิตรในหลากหลายอุตสาหกรรม ยึดมั่นในความซื่อสัตย์และคุณภาพ เพื่อสร้างคุณค่าร่วมกัน",
        index: 3,
    },
    {
        index: 4,
    }
];
</script>
<style scoped lang="less">
.home-top {
    height: 518px;
    padding: 0 196px;
    display: flex;
    align-items: center;

    .top-content {
        font-weight: bold;
        font-size: 41px;
        color: #4D4D4D;
        line-height: 62px;
    }

    .top-img {
        width: 587px;
        height: 518px;
        object-fit: cover;
    }
}


.home-about {
    width: 100%;
    height: 362px;
    background: url('../assets/about-bg.webp') no-repeat;
    background-size: 100% 100%;
    padding-top: 33px;

    .about-title {
        font-weight: bold;
        font-size: 35px;
        color: #FFFFFF;
        line-height: 25px;
        text-align: center;
        margin-bottom: 33px;
    }

    .about-content {
        padding: 0 196px;
        display: flex;
        align-items: center;

        .content-img {
            width: 263px;
            height: 246px;
            object-fit: cover;
            margin-right: 50px;
        }

        .content-text {
            font-weight: 500;
            font-size: 15px;
            color: #FFFFFF;
            line-height: 30px;
        }
    }
}

.title {
    font-weight: bold;
    font-size: 44px;
    color: #333333;
    line-height: 40px;
    text-align: center;
    margin: 53px 0;
    position: relative;
}

.home-service {
    margin-bottom: 70px;

    .service-title {
        font-weight: bold;
        font-size: 35px;
        color: #4D4D4D;
        line-height: 35px;
        text-align: center;
        margin-bottom: 22px;

        &::before {
            content: "";
            width: 113px;
            height: 25px;
            background: url(../assets/service-title.webp) no-repeat;
            background-size: 100% 100%;
            display: block;
            margin: 48px auto 10px;
        }
    }

    .service-dics {
        padding: 0 292px;
        font-weight: 500;
        font-size: 15px;
        color: #4D4D4D;
        line-height: 20px;
        text-align: center;
        margin-bottom: 16px;
    }

    .service-content {
        padding: 0 196px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .content-item {
            width: 500px;
            height: 263px;
            border-radius: 15px 15px 15px 15px;
            border: 2px solid #D9D9D9;
            box-sizing: border-box;
            padding: 20px 9px;
            margin-bottom: 46px;

            .item-title {
                font-weight: bold;
                font-size: 27px;
                color: #4D4D4D;
                line-height: 27px;
                text-align: center;
                margin-bottom: 16px;
            }

            .item-content {
                display: flex;
                align-items: center;

                .item-img {
                    width: 189px;
                    height: 181px;
                    object-fit: cover;
                    margin-right: 10px;
                }

                .item-text {
                    font-weight: 500;
                    font-size: 18px;
                    color: #4D4D4D;
                    line-height: 30px;
                }
            }

            .item-more {
                width: 86px;
                height: 15px;
                object-fit: cover;
                display: block;
                margin: 105px auto 0;
            }
        }
    }
}
</style>